import type { LangId } from "@aybuben/core/lang.ts";
import { ArrowLeft } from "lucide-react";
import { Outlet, useLocation, useNavigate } from "react-router";

import { StringsProvider, useStrings } from "../i18n/index.tsx";
import { COL, FOCUS } from "../theme.ts";
import { LangPill } from "../ui/LangPill.tsx";
import { Shell } from "../ui/primitives.tsx";

interface AuthLayoutProps {
	lang: LangId;
	onLang: (l: LangId) => void;
}

export default function AuthLayout({ lang, onLang }: AuthLayoutProps) {
	return (
		<StringsProvider lang={lang}>
			<Shell>
				<TopBar lang={lang} onLang={onLang} />
				<Outlet />
			</Shell>
		</StringsProvider>
	);
}

function TopBar({ lang, onLang }: AuthLayoutProps) {
	const t = useStrings();
	const navigate = useNavigate();
	const location = useLocation();
	// A deep link has nothing in-app behind it; onboarding is the way back.
	const back = () => (location.key === "default" ? navigate("/welcome") : navigate(-1));
	return (
		<div className="flex items-center justify-between px-4 pt-4">
			<button
				onClick={back}
				aria-label={t("auth.back")}
				className={`-ml-1 rounded-full p-1 ${FOCUS}`}
				style={{ color: COL.mute }}
			>
				<ArrowLeft size={22} />
			</button>
			<LangPill lang={lang} onLang={onLang} />
		</div>
	);
}
